// extracted by mini-css-extract-plugin
module.exports = {"button":"global_button__3Mjl3","red":"global_red__3SsOD","facebook":"global_facebook__1VHt0","disabled":"global_disabled__cqwYG","success":"global_success__eVcWN"};